module.exports = __webpack_public_path__ + "static/media/mongodb.4643494b.svg";